import AXIOS from '@/utils/$axios';

export const getDecorationList = data =>
    AXIOS.post('/space/scheme/design/get-list', data);

export const getDecorationDetail = data =>
    AXIOS.post('/space/scheme/design/detail', data);

export const renameScheme = data => AXIOS.post('/scheme/design/rename', data);

export const deleteScheme = data => AXIOS.post('/scheme/design/delete', data);

export const schemeBatchOperation = data =>
    AXIOS.post('/space/scheme/common/scheme-do-batch', data);

export const updateScheme = data =>
    AXIOS.post('/space/scheme/design/sycn-file', data);
